import father from '../images/testimonials/father_testimony.png';
import anvikaImg from '../images/testimonials/anvika_testimony.png';
import aravindImg from '../images/testimonials/aravind_testimony.png';
import podcast from '../images/testimonials/podcast.png';
export const testimonialsData = [
  {
    id: 1,
    title: "A Happy Father - Gr8 Appers",
    url: "http://www.youtube.com/watch?v=pVHeyT3vu94",
    video_id: "pVHeyT3vu94",
    img: father,
  },
  {
    id: 2,
    title: "Happy Student - Gr8 Appers",
    url: "http://www.youtube.com/watch?v=Z_mtXlhGG1k",
    video_id: "Z_mtXlhGG1k",
    img: anvikaImg,
  },
  {
    id: 3,
    title: "Aravind, Another Happy Father About Gr8 Appers.",
    url: "http://www.youtube.com/watch?v=lnHFru6Uo24",
    video_id: "lnHFru6Uo24",
    img: aravindImg,
  },
    {
    id: 4,
    title: "Skill Assessment and Career Counselling. Gr8 Appers.",
    url: "http://www.youtube.com/watch?v=YZnJjGi5Bzg",
    video_id: "YZnJjGi5Bzg",
    img: podcast,
  }
];
